import { render, staticRenderFns } from "./HomePrograms.vue?vue&type=template&id=ae78b8ce&scoped=true&"
import script from "./HomePrograms.vue?vue&type=script&lang=js&"
export * from "./HomePrograms.vue?vue&type=script&lang=js&"
import style0 from "./HomePrograms.vue?vue&type=style&index=0&id=ae78b8ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae78b8ce",
  null
  
)

export default component.exports